import { Box,  Grid,  LinearProgress, Slide, Typography, useTheme } from "@mui/material"
import { useEffect, useState } from "react"
import { LanguageSelection } from "./Components/LanguageSelection"
import { ProfileSelection } from "./Components/ProfileSelection"
import { CodeVerification } from "./Components/CodeVerification"
import { AccountCreated } from "./Components/AccountCreated"
import { useAppDispatch, useAppSelector } from "../../Redux/store"
import { ProfileDetails } from "./Components/ProfileDetails"
import { ClientTypeSelection } from "./Components/ClientTypeSelection"
import { UserDetails } from "./Components/UserDetails"
import { resetState, setProgress } from "./Slices/accountCreationSlice"
import { CompanyDetails } from "./Components/CompanyDetails"
import { setIsLoggedIn } from "../../Redux/slices/GlobalSlice"
import { ClientType } from "../../Types/Client"
import { DataConsent } from "./Components/DataConsent"
import IdentityVerification from "./Components/IdentityVerification"
import { useNavigate } from "react-router-dom"
import { RouteUrls } from "../../Routes/RouteUrls"

export const AccountCreation = () => {
    /* ******************** Hooks ******************** */
    const accountCreationSlice = useAppSelector(state => state.AccountCreation);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    dispatch(setIsLoggedIn(false));
    /* ******************** Variables ******************** */
    const getView = () =>{
        switch(accountCreationSlice.Progress){
            case 25:
                // return <LanguageSelection />;
            case 50:
                return <ProfileSelection />;
            case 60:
                // return <ClientTypeSelection />;
            case 75:
                return accountCreationSlice.ClientType !== ClientType['Company'] ? <UserDetails /> : <CompanyDetails />;
            case 80:
                return <ProfileDetails />;
            case 90:
                return <CodeVerification />;
            case 95:
                return <DataConsent />;
            case 100:
                navigate(RouteUrls.AccountCreated);
                return null;
        }
    }
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    // Initilize account creation progress
    useEffect(()=>{
        dispatch(setProgress(25));
        dispatch(resetState());
    }, []);
    /* ******************** JSX ******************** */
    return (
        <Grid
            item
            bgcolor={'green.50'}
            width={"100%"}
            height={"100%"}
            overflow={"hidden"}
            display={"grid"}
            gridTemplateRows={"repeat(2, min-content)"}
            justifyItems={"center"}
            paddingY={6}
        >
            <Grid item xs display={"grid"} gridTemplateColumns={"1fr"}  gridTemplateRows={"repeat(3, min-content)"} justifyItems={"center"}>
                <Typography variant="lora-display-small" marginBottom={"12px"}>{accountCreationSlice.Progress === 95? 'Using our services': 'Create an account'}</Typography>
                <Typography variant="body-large" marginBottom={"20px"}>{accountCreationSlice.Subtitle}</Typography>
                {
                    accountCreationSlice.Progress < 100 &&
                    <Box width={"290px !important"} marginBottom={"30px"}>
                        <LinearProgress variant="determinate" value={accountCreationSlice.Progress}/>
                    </Box>
                }
            </Grid>             
            <Grid 
                item 
                xs="auto" 
            >
                <Box                               
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        height: "fit-content"
                    }}
                >
                    {getView()}
                </Box>
            </Grid>
        </Grid>
    )
}